module.exports = __webpack_public_path__ + "components/MapControl/svg/Kirkut.svg?b492ec50";


//////////////////
// WEBPACK FOOTER
// ./components/MapControl/svg/Kirkut.svg
// module id = 2048
// module chunks = 0